// extracted by mini-css-extract-plugin
export default {"jump":"HeaderCartButton_jump__q1+1p","badge":"HeaderCartButton_badge__bGT5f"};